/**
 * Product Media Group - Shared JS
 */
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-media-groups]').forEach(function (container) {
    const instance = new ProductMediaGroups(container);
    // Store instance reference for external access
    container.__mediaGroupsInstance = instance;
  });
});

class ProductMediaGroups {
  constructor(container) {
    this.container = container;
    this.currentGroup = null;
    this.currentIndex = 0;
    this.groups = {};

    this.init();
  }

  init() {
    var self = this;

    this.container.querySelectorAll('[data-group]').forEach(function (group) {
      var key = group.dataset.group;
      var items = group.querySelectorAll('[data-group-item]');
      if (items.length > 0) {
        self.groups[key] = {
          element: group,
          items: Array.from(items),
          count: items.length
        };
      }
    });

    var groupKeys = Object.keys(this.groups);
    if (groupKeys.length > 0) {
      this.currentGroup = groupKeys[0];
    }

    this.bindEvents();
    this.updateCounter();
    this.updateNavButtons();
  }

  bindEvents() {
    var self = this;

    this.container.querySelectorAll('[data-group-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        self.switchGroup(thumb.dataset.groupThumb);
      });
    });

    var prevBtn = this.container.querySelector('[data-nav-prev]');
    var nextBtn = this.container.querySelector('[data-nav-next]');

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        self.navigate(-1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        self.navigate(1);
      });
    }

    this.bindImageSwipe();
  }

  bindImageSwipe() {
    this.container.querySelectorAll('[data-swipe-gallery]').forEach((gallery) => {
      let gesture = null;

      gallery.addEventListener('pointerdown', (event) => {
        // Leave desktop, multi-touch zoom, and interactive controls alone.
        const group = this.groups[this.currentGroup];
        if (!event.isPrimary) {
          gesture = null;
          return;
        }
        if (event.pointerType !== 'touch' || !window.matchMedia('(max-width: 1024px)').matches ||
            group?.element !== gallery || group.count < 2 ||
            event.target.closest('button, a, input, select, video, iframe, product-model')) return;

        gesture = { id: event.pointerId, x: event.clientX, y: event.clientY, axis: null };
      });

      gallery.addEventListener('pointermove', (event) => {
        if (!gesture || gesture.id !== event.pointerId || gesture.axis) return;
        const dx = Math.abs(event.clientX - gesture.x);
        const dy = Math.abs(event.clientY - gesture.y);
        if (Math.max(dx, dy) < 10) return;
        // Lock once: a vertical/diagonal scroll cannot become a horizontal swipe.
        gesture.axis = dx > dy * 1.25 ? 'horizontal' : 'vertical';
      });

      gallery.addEventListener('pointerup', (event) => {
        if (!gesture || gesture.id !== event.pointerId) return;
        const { x, y, axis } = gesture;
        gesture = null;
        const dx = event.clientX - x;
        const dy = event.clientY - y;
        if (axis !== 'horizontal' || Math.abs(dx) < 40 || Math.abs(dx) <= Math.abs(dy) * 1.25 ||
            this.groups[this.currentGroup]?.element !== gallery) return;
        this.navigate(dx < 0 ? 1 : -1);
      });

      gallery.addEventListener('pointercancel', () => { gesture = null; });
    });
  }

  switchGroup(groupKey) {
    if (!this.groups[groupKey]) return;

    this.pauseMedia();

    if (this.groups[this.currentGroup]) {
      this.groups[this.currentGroup].element.hidden = true;
    }

    this.currentGroup = groupKey;
    this.currentIndex = 0;
    this.groups[groupKey].element.hidden = false;

    var self = this;
    this.container.querySelectorAll('[data-group-thumb]').forEach(function (t) {
      var isActive = t.dataset.groupThumb === groupKey;
      t.classList.toggle('active', isActive);
      t.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });

    this.showItem(0);
    this.updateCounter();
    this.updateNavButtons();
  }

  navigate(direction) {
    var group = this.groups[this.currentGroup];
    if (!group) return;

    var newIndex = this.currentIndex + direction;
    if (newIndex < 0) newIndex = group.count - 1;
    if (newIndex >= group.count) newIndex = 0;

    this.showItem(newIndex);
  }

  showItem(index) {
    var group = this.groups[this.currentGroup];
    if (!group) return;

    this.pauseMedia();

    group.items.forEach(function (item, i) {
      item.classList.toggle('is-active', i === index);
    });

    this.currentIndex = index;
    this.updateCounter();
    this.updateNavButtons();
  }

  updateCounter() {
    var group = this.groups[this.currentGroup];
    var currentEl = this.container.querySelector('[data-current-index]');
    var totalEl = this.container.querySelector('[data-total-count]');

    if (currentEl) currentEl.textContent = this.currentIndex + 1;
    if (totalEl) totalEl.textContent = group ? group.count : 0;
  }

  updateNavButtons() {
    var group = this.groups[this.currentGroup];
    var prevBtn = this.container.querySelector('[data-nav-prev]');
    var nextBtn = this.container.querySelector('[data-nav-next]');

    if (!group || group.count <= 1) {
      if (prevBtn) prevBtn.style.display = 'none';
      if (nextBtn) nextBtn.style.display = 'none';
    } else {
      if (prevBtn) prevBtn.style.display = '';
      if (nextBtn) nextBtn.style.display = '';
    }
  }

  pauseMedia() {
    this.container.querySelectorAll('video').forEach(function (v) {
      v.pause();
    });

    this.container.querySelectorAll('iframe').forEach(function (iframe) {
      try {
        if (iframe.src.indexOf('youtube') !== -1) {
          iframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
        } else if (iframe.src.indexOf('vimeo') !== -1) {
          iframe.contentWindow.postMessage('{"method":"pause"}', '*');
        }
      } catch (e) {}
    });

    this.container.querySelectorAll('product-model').forEach(function (model) {
      if (model.pauseModel) {
        model.pauseModel();
      }
    });
  }
}
